var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10076",
    "data-name": "Group 10076",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.224,
    height: 17.021,
    viewBox: "0 0 29.224 17.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4833",
    "data-name": "Rectangle 4833",
    width: 29.224,
    height: 17.021,
    fill: "#d13c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10075",
    "data-name": "Group 10075",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5668",
    "data-name": "Path 5668",
    d: "M25.524,1.405V12.8a.775.775,0,0,1-.745.368l-3.585-.032c-.421,0-.526-.474-.623-.8a84.972,84.972,0,0,0-2.876-8.071,11.2,11.2,0,0,0-.558-1.169c-.083-.155-.206-.364-.091-.546a1.248,1.248,0,0,1,.337-.341A22,22,0,0,1,24.838.978a.667.667,0,0,1,.686.427",
    transform: "translate(3.7 0.212)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5669",
    "data-name": "Path 5669",
    d: "M15.622,10.825,19.078,14.3a1.145,1.145,0,0,1-1.426.509L14.5,11.689a.566.566,0,0,0-.787.072.572.572,0,0,0-.022.791l2.821,2.83a.9.9,0,0,1-.419.662c-.216.11-.636.214-.833.018L12.7,13.54a.594.594,0,0,0-.863.8l2,2.016a3.13,3.13,0,0,1-2.194-.745C9.859,14.272,8.108,12.953,6.4,11.509a16.234,16.234,0,0,1-1.2-1.224,63.88,63.88,0,0,0,1.942-7.3l2.418.007A7.186,7.186,0,0,0,8.07,5.3a3.065,3.065,0,0,0-.219,1.209,1.51,1.51,0,0,0,1.2,1.384A3.041,3.041,0,0,0,12.5,6.634a2.3,2.3,0,0,0,1.336-.492l2.89,2.346c.906.735,1.791,1.415,2.653,2.2.743.676,2.065,1.891,1.481,2.674a.726.726,0,0,1-.779.22L16.47,10a.594.594,0,0,0-.847.822",
    transform: "translate(1.133 0.649)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5670",
    "data-name": "Path 5670",
    d: "M6.482,6.057,4.923,11.54a.628.628,0,0,1-.64.611l-3.708,0A.563.563,0,0,1,0,11.573L0,.743C0,.475.142,0,.457,0A28.968,28.968,0,0,1,4,.332C5.035.474,6.653.77,7.24,1.488c.259.315-.482,3.6-.759,4.569",
    transform: "translate(0 0)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5671",
    "data-name": "Path 5671",
    d: "M14.31,5.419c-1.117-.961-1.615.058-2.568.161a.9.9,0,0,0-.8.431,1.681,1.681,0,0,1-2.426.7A1.3,1.3,0,0,1,8.6,5.926a5.757,5.757,0,0,1,1.441-2.091c1.108-1.07,2.175-2.052,3.763-1.672a9.446,9.446,0,0,1,1.314.459c1.053.418,2.071.828,3.145,1.168a22.524,22.524,0,0,1,.923,2.183l1.984,5.544a30.47,30.47,0,0,0-2.186-2.15L16.7,7.476Z",
    transform: "translate(1.848 0.452)",
    fill: "#d13c3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecover);
export default __webpack_public_path__ + "static/media/recover.244903cf8a0a9fc7709a35f8d15ac81e.svg";
export { ForwardRef as ReactComponent };